import React from 'react'
import DynamicColor from '../common/dynamic-color'
import { COLOR_NAME } from '../../constants'

const AmountButton = ({ className = '', add, ...props }) => {
    return (
        <DynamicColor
            className={`btn-change-amount ${className}`}
            style={{
                // borderColor: COLOR_NAME.BUTTON_BG,
                // color: COLOR_NAME.BUTTON_TEXT,
            }}
            {...props}
        >
            <i className={add ? 'fas fa-plus' : 'fas fa-minus'} />
        </DynamicColor>
    )
}

export default AmountButton
